import React from 'react';
import { LegalShell } from '../components/legal/LegalShell';
export function Terminos() {
  return <LegalShell title="Términos y condiciones" data-id="element-1222">
      <p data-id="element-1223">Al acceder y utilizar LOS 12 aceptas estos términos.</p>
      <p data-id="element-1224">
        El contenido (libros, archivos PDF, rituales y materiales digitales) es
        de uso personal e intransferible. No está permitida su reventa,
        redistribución ni reproducción parcial o total.
      </p>
      <p data-id="element-1225">
        El acceso al Portal de Usuario es individual. Compartir credenciales
        puede provocar la suspensión inmediata de la cuenta.
      </p>
      <p data-id="element-1226">
        LOS 12 es un proyecto simbólico y de exploración personal. No sustituye
        asesoría psicológica, médica ni profesional de ningún tipo.
      </p>
      <p data-id="element-1227">
        Nos reservamos el derecho de actualizar estos términos en cualquier
        momento.
      </p>
    </LegalShell>;
}